export default __webpack_public_path__ + "images/3c985d6ca9637398656293fa54796c75-halloweenhaunt.webp";